在子组件实现全部折叠/展开时,可以在子组件加入如下代码

```
changeExpand(row,expandedRows){
        this.isExpandAll = expandedRows;
      },
      toggleExpandAll() {
        this.isExpandAll = !this.isExpandAll;
        this.toggleRowExpansionAll(this.tableData, this.isExpandAll);
      },
      toggleRowExpansionAll(data, isExpandAll) {
        data.forEach((item) => {
            this.$refs.myTableRef.getTableDom().toggleRowExpansion(item, isExpandAll);
            if (item.children !== undefined && item.children !== null) {
              this.toggleRowExpansionAll(item.children, isExpandAll);
            }
        });
      },
```
